import { render, staticRenderFns } from "./BookingFilters.vue?vue&type=template&id=3b43b50c"
import script from "./BookingFilters.vue?vue&type=script&lang=js"
export * from "./BookingFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports